module.exports = __webpack_public_path__ + "static/img/abi-ad.5c79f46d.jpg";